module.exports = __WEBPACK_EXTERNAL_MODULE_258__;


//////////////////
// WEBPACK FOOTER
// external "vue"
// module id = 258
// module chunks = 0